require('../../modules/es6.number.max-safe-integer');
module.exports = 0x1fffffffffffff;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/max-safe-integer.js
// module id = dSOO
// module chunks = 22